class MemProductTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(index));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });
  }

  activate(index, focus = false) {
    this.tabs.forEach((tab, tabIndex) => {
      const selected = tabIndex === index;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
      if (focus && selected) tab.focus();
    });
    this.panels.forEach((panel, panelIndex) => {
      panel.hidden = panelIndex !== index;
    });
  }

  onKeydown(event, index) {
    let next = null;
    if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
    if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = this.tabs.length - 1;
    if (next !== null) {
      event.preventDefault();
      this.activate(next, true);
    }
  }
}

if (!customElements.get('mem-product-tabs')) {
  customElements.define('mem-product-tabs', MemProductTabs);
}
